module.exports = "//static.hsappstatic.net/pricing-pages-unified-ui/static-1.5591/js/img/mon317/classpass-2x.jpg"


//////////////////
// WEBPACK FOOTER
// ../node_modules/bender-webpack/lib/bender-url-loader.js!./js/img/mon317/classpass-2x.jpg
// module id = 881
// module chunks = 5 6